import type { UrlLocation } from '@seek/chalice-types';

import type { Country } from 'src/types/globals';

export const LOCATION_CHANGED = 'LOCATION_CHANGED';
export const CAMPAIGN_LINK_CLICKED = 'CAMPAIGN_LINK_CLICKED';
export const SET_REQUEST_ID = 'SET_REQUEST_ID';
export const COUNTRY_CHANGED = 'COUNTRY_CHANGED';

export interface LocationState {
  url: string | null;
  pathname: string;
  prevPathname: string | null;
  query: any;
  pageNumber?: number;
  isHomepage: boolean;
  hostname?: string;
  href?: string;
  hash?: string;
  port?: string;
  protocol?: string;
  requestId?: string;
}

interface CountryChangedAction {
  type: typeof COUNTRY_CHANGED;
  payload: {
    country: Country;
  };
}

interface LocationChangedAction {
  type: typeof LOCATION_CHANGED;
  payload: {
    url: string;
    location: UrlLocation;
  };
}

export interface SetRequestIdAction {
  type: typeof SET_REQUEST_ID;
  payload: {
    requestId?: string;
  };
}

export type LocationAction =
  | LocationChangedAction
  | CountryChangedAction
  | SetRequestIdAction
  | {
      type: typeof CAMPAIGN_LINK_CLICKED;
      payload: {
        linkName: string;
        trackingCode: string;
      };
    };
